import type {
  ActionReference,
  RecordListInputConfig,
} from "@smartsuite/automation-engine-api";
import { RecordListInputConfig_Reference } from "@smartsuite/automation-engine-api";

export const recordListInputConfigToOptionValue = (
  recordList?: RecordListInputConfig,
): string | undefined => {
  if (recordList === undefined) {
    return undefined;
  }
  switch (recordList.recordList.oneofKind) {
    case "actionReference":
      return `${recordList.recordList.actionReference.actionId}_${recordList.recordList.actionReference.instanceId}`;
    case "reference":
      return recordList.recordList.reference ===
        RecordListInputConfig_Reference.FROM_TRIGGER
        ? "trigger"
        : undefined;
    default:
      return undefined;
  }
};

export const compareActionReferences = (
  left: ActionReference,
  right: ActionReference,
): boolean =>
  left.actionId === right.actionId &&
  left.integrationId === right.integrationId &&
  left.instanceId === right.instanceId;
